import React, {useCallback} from 'react';
import {GatewayGetSchema} from '../../../../../api/DBSchema/Gateway';
import {useTranslation} from 'react-i18next';
import SMCLabel from '../../../../../components/Simple/SMCLabel';
import SMCNumberInput from '../../../../../components/Simple/SMCNumberInput';
import EditorLayout from '../../../../../components/Layouts/EditorLayout';
import RowLayout from '../../../../../components/Layouts/RowLayout';
import gatewaysBehindNatImage from '../../../../../assets/images/gateway_behind_nat_visual.png';
import EmptyRow from '../../../../../components/Simple/EmptyRow';

const pageSchema = GatewayGetSchema.pages.gatewaysBehindNAT;
const pageId = pageSchema.pageId;

function BaseGatewaysBehindNat({
    pageData,
    setObjectData,
    pageDisabled
}) {
    const { t } = useTranslation();
    
    const setPageValue = useCallback((param, newValue) => {
        setObjectData([pageId, param], newValue);
    }, [setObjectData]);

    const mgmtPort = pageData[pageSchema.mgmtPort];
    const sicPort  = pageData[pageSchema.sicPort];

    return (
        <EditorLayout labelWidth={250}>
                {/* Local admin access port */}
                <RowLayout spacing="8px">
                    <SMCNumberInput
                        disabled={pageDisabled}
                        value={mgmtPort}
                        onChange={e => setPageValue(pageSchema.mgmtPort, parseInt(e.target.value))}
                        label={t('SMP.PLAN.SERVICES.GW_BEHIND_NAT.LINE1')}
                        width={100}
                        inline
                    />
                    <SMCLabel>{t('SMP.PLAN.SERVICES.GW_BEHIND_NAT.DEFAULT_PORT')} 4434</SMCLabel>
                </RowLayout>
                {/* SIC port */}
                <RowLayout spacing="8px">
                    <SMCNumberInput
                        disabled={pageDisabled}
                        value={sicPort}
                        onChange={e => setPageValue(pageSchema.sicPort, parseInt(e.target.value))}
                        label={t('SMP.PLAN.SERVICES.GW_BEHIND_NAT.LINE2')}
                        width={100}
                        inline
                    />
                    <SMCLabel>{t('SMP.PLAN.SERVICES.GW_BEHIND_NAT.DEFAULT_PORT')} 18191</SMCLabel>
                </RowLayout>
                
                <EmptyRow />
                
                <div>
                    <img src={gatewaysBehindNatImage} alt="" />
                </div>

                <EmptyRow />
                
                <SMCLabel><b>{t('SMP.DESCRIPTION')}: </b>{t('SMP.PLAN.SERVICES.GW_BEHIND_NAT.LINE3')}</SMCLabel>
                
                <EmptyRow />
                
                <SMCLabel><b>{t('SMP.PLAN.SERVICES.GW_BEHIND_NAT.ALLOW_ACCESS')}: </b>{t('SMP.PLAN.SERVICES.GW_BEHIND_NAT.LINE4')}</SMCLabel>
        </EditorLayout>
    );
}

export default BaseGatewaysBehindNat;